import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { LANGUAGE_KEY } from '@shared/constants';

import { i18Namespace } from './i18nNamespaces';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from './languageMap';
import { Language } from './languages';
import {
	deTranslations,
	enTranslations,
	esTranslations,
	frTranslations,
	hrTranslations,
	itTranslations,
	lvTranslations,
	nlTranslations,
	plTranslations,
	ptTranslations,
	trTranslations,
} from './locales';

const resources = {
	[Language.DE]: deTranslations,
	[Language.EN]: enTranslations,
	[Language.ES]: esTranslations,
	[Language.FR]: frTranslations,
	[Language.HR]: hrTranslations,
	[Language.IT]: itTranslations,
	[Language.LV]: lvTranslations,
	[Language.NL]: nlTranslations,
	[Language.PL]: plTranslations,
	[Language.PT]: ptTranslations,
	[Language.TR]: trTranslations,
};

const getInitialLanguage = () => {
	try {
		const persisted = localStorage.getItem(`persist:${LANGUAGE_KEY}`);
		if (persisted) {
			const parsed = JSON.parse(persisted);
			const lang = JSON.parse(parsed.currentLanguage);
			if (SUPPORTED_LANGUAGES.includes(lang)) return lang;
		}
	} catch {
		// ignore
	}
	return DEFAULT_LANGUAGE;
};

i18n.use(initReactI18next).init({
	resources,
	lng: getInitialLanguage(),
	fallbackLng: DEFAULT_LANGUAGE,
	supportedLngs: SUPPORTED_LANGUAGES,
	ns: [i18Namespace.translation, i18Namespace.validForm, i18Namespace.toast],
	defaultNS: i18Namespace.translation,
	interpolation: {
		escapeValue: false,
	},
	react: {
		useSuspense: false,
	},
});

export default i18n;
